<template>
  <div>
    <v-card
      flat
      :class="`product-container pb-0 ${
        $vuetify.theme.dark ? 'card-dark-border' : 'card-light-border'
      }`"
    >
      <v-img
        :src="product.webImage ? `${product.webImage}?w=236&h=133&fit=crop` : defaultImage"
        :lazy-src="$options.lazyImage"
        :aspect-ratio="imgAspect"
        class="grey lighten-2 pointer"
        @click="routeToProduct"
      >
        <template v-slot:placeholder>
          <v-layout fill-height align-center justify-center ma-0>
            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
          </v-layout>
        </template>
      </v-img>

      <v-chip
        label
        color="#ffcc00"
        text-color="#000000"
        class="promotion-tag"
        v-if="(product.promotion || product.discountPrice) && !loading"
      >
        {{ utility_discountPercentage(product, regularPrice, discountPrice) }}
      </v-chip>

      <v-card-title
        primary-title
        :class="`${$vuetify.theme.dark ? '' : 'grey--text text--darken-1'} card-title  pt-4`"
      >
        <v-card-text class="pa-0">
          <router-link
            v-if="!simpleProduct"
            :to="{
              name: 'productDetails',
              props: true,
              params: {
                productId,
                product,
                title: this.$route.params.title,
                category: promotion
                  ? 'promotions'
                  : this.$route.params.category.split(' ').join('').toLowerCase(),
              },
            }"
          >
            <h2>{{ product.webTitle }}</h2>
          </router-link>
          <h3 class="text-center" v-else>{{ product.webTitle }}</h3>
        </v-card-text>
      </v-card-title>

      <!-- <v-card-text class="text-xs-center title grey--text text--darken-1 pt-1">
        {{ product.priceInDollars | utility_formatCurrency }}
      </v-card-text> -->

      <!-- <v-card-text class="text-xs-left">
        <span class="caption grey--text">Category:</span>
        <span>{{ product.productType }}</span>
      </v-card-text> -->

      <v-btn
        v-if="!simpleProduct"
        color="primary"
        :class="[
          product && !product.webExcerpt ? 'mb-4' : '',
          $vuetify.theme.dark ? 'lighten-1' : '',
        ]"
        :to="{
          name: 'productDetails',
          props: true,
          params: {
            productId,
            product,
            title: this.$route.params.title,
            category: promotion
              ? 'promotions'
              : this.$route.params.category.split(' ').join('').toLowerCase(),
          },
        }"
      >
        {{ $t('store.shop') }}
      </v-btn>

      <v-card-actions class="pb-4" v-if="simpleProduct">
        <v-btn
          v-if="simpleProduct"
          :class="[$vuetify.theme.dark ? 'lighten-1' : '']"
          color="primary"
          small
          block
          @click.prevent="addToCart(product)"
        >
          {{ $t('general.select') }}
        </v-btn>
      </v-card-actions>

      <v-card-actions class="pb-0" v-else-if="product && product.webExcerpt">
        <span :class="`${$vuetify.theme.dark ? '' : 'grey--text text--darken-1'}`">
          {{ $t('store.general.details') }}
        </span>
        <v-spacer></v-spacer>
        <v-btn
          icon
          :class="`${$vuetify.theme.dark ? '' : 'grey--text text--darken-1'}`"
          @click.native="show = !show"
        >
          <v-icon dark>{{ show ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
        </v-btn>
      </v-card-actions>

      <v-slide-y-transition>
        <v-card-text v-show="show" class="text-left">
          {{ product.webExcerpt }}
        </v-card-text>
      </v-slide-y-transition>
    </v-card>

    <!-- <v-flex xs12> -->
    <!-- <v-layout row wrap>
        <v-flex xs12>
          <v-card color="red darken-4" class="white--text">
            <v-card-title primary-title>
              <v-flex xs12 class="headline">{{ product.titleText || 'Product Title' }}</v-flex>
              <v-flex xs12>{{ product.subtitleText }}</v-flex>
              <v-flex xs12>{{ product.skuCode }}</v-flex>
              <v-flex v-if="product.priceInDollars" xs12 class="white--text display-2 mt-12">
                ${{ product.priceInDollars }}
              </v-flex>
              <v-flex v-else xs12 class="white--text display-2 mt-12">Free</v-flex>
            </v-card-title>
            <v-card-actions>
              <router-link
                :to="{
                  name: 'productDetails',
                  props: true,
                  params: {
                    productId,
                  },
                }"
              >
                <v-btn flat dark>Details</v-btn>
              </router-link>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="show = !show">
                <v-icon dark>{{ show ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
              </v-btn>
            </v-card-actions>
            <v-slide-y-transition>
              <v-card-text v-show="show">
                {{ product.skuCode }} Lorem ipsum dolor sit amet...
              </v-card-text>
            </v-slide-y-transition>
          </v-card>
        </v-flex>
      </v-layout> -->

    <!-- <v-card>
        <v-card-title primary-title>
          <h3 class="headline">{{product.titleText || 'Product Title'}}</h3>
        </v-card-title>
        <div>
          <p>{{ product.subtitleText }}</p>
        </div>
        <div>
          <p>{{ product.smallDescriptionText }}</p>
        </div>
        <div>
          <p>{{ product.skuCode }} - {{ product.productType }}</p>
          <p>{{ product.productCategory }}</p>
          <p>{{ product.priceInDollars }}</p>
        </div>
        <v-card-actions> -->
    <!-- <v-btn color="primary" @click="redirectToCheckout(product)">Purchase</v-btn> -->
    <!-- <router-link
            :to="{
              path: `/productdetails/${productId}`,
              props: true,
              name: 'productDetails',
              params: {
                productId,
                product,
              }
            }"
          >
            <v-btn color="primary">Details</v-btn>
          </router-link>
        </v-card-actions>
      </v-card> -->
    <!-- </v-flex> -->
  </div>
</template>

<script>
/**
 * @params for Product Component
 * @ productId: Product sku or plan ID. Entered as a string. ex: productId="sku_FkshlfpsFchM5e"
 * @ product: Product object. Entered as the product itself. ex: product="product"
 * */

import utilityMixin from '@/mixins/utilityMixin';
import { lazyProductImageTG } from '@/lib/constants';

//! This is under my personal Stripe account (TruGolf Dev Account) publishable key
// const stripe = window.Stripe(`pk_test_lgd2cQrq5gKYjpXm53plS7uf00akWsR6wL`)

export default {
  name: 'Product',
  mixins: [utilityMixin],

  props: {
    productId: String,
    product: Object,
    loading: Boolean,
    promotion: {
      type: Boolean,
      default: false,
    },
    simpleProduct: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      show: false,
      defaultImage: `https://picsum.photos/400/315?random=${Math.floor(Math.random()) * 5 + 10}`,
      lazyImage:
        'https://e6golf-qa-assets.imgix.net/uploads/clubhouses/branding/e6Connect_logo_1.jpg?blur=70&w=100?crop=true',
    };
  },

  created() {
    //* non-reactive constants
    this.$options.lazyImage = lazyProductImageTG;
  },

  computed: {
    imgAspect() {
      if (this.utility_isObject(this.product)) {
        if (!this.product?.webImage) {
          return '1.39';
        }

        const img = new Image();
        img.src = this.product?.webImage;
        img.onload = () => {
          return img?.width / img?.height;
        };
        return img?.width / img?.height;
      }
    },

    regularPrice() {
      if (this.product?.pricings) {
        const regular = this.product?.pricings?.find((price) => {
          return price.Active && price.pricingType === 'regular';
        });
        // console.log('regular:', regular);
        return regular || {};
      }
    },

    resellerPrice() {
      if (this.product?.pricings) {
        const reseller = this.product?.pricings?.find((price) => {
          return price.Active && price.pricingType === 'reseller';
        });
        return reseller || {};
      }
    },

    discountPrice() {
      if (this.product?.pricings) {
        const discount = this.product?.pricings?.find((price) => {
          return price.Active && price.pricingType === 'discount';
        });
        return discount || {};
      }
    },
  },

  methods: {
    // redirectToCheckout(data) {
    //   const { productInfo } = data
    //   stripe.redirectToCheckout({
    //     items: [
    //       {
    //         ...productInfo,
    //         quantity: 1
    //       }
    //     ],
    //     successUrl: 'http://localhost:8080/store',
    //     cancelUrl: 'http://localhost:8080/store'
    //   })
    //     .then(result => {
    //       console.log('result:', result)
    //       //* If `redirectToCheckout` fails due to a browser or network
    //       //* error, display the localized error message to your customer
    //       //* using `result.error.message`.
    //     })
    // }

    routeToProduct() {
      if (this.simpleProduct) {
        return;
      }
      const categoryFormat = this.$route?.params?.category?.split(' ')?.join('')?.toLowerCase();

      this.$router
        .push({
          name: 'productDetails',
          props: true,
          params: {
            productId: this.productId,
            product: this.product,
            title: this.$route.params.title,
            category: this.promotion ? 'promotions' : categoryFormat || 'promotions',
          },
        })
        .catch(() => {});
    },

    addToCart(product) {
      this.$emit('addToCartUpgrade', product);
    },
  },
};
</script>

<style scoped>
.product-container {
  border: none;
  border-radius: 10px;
  /* background-color: #fff; */
  /* min-height: 32vh; */
  min-height: 290px;
}

.theme--dark .product-container {
  background-color: var(--grey-dark, #5e5e5e);
}

.theme--dark.sidebar-nav .product-container {
  background-color: var(--grey-darker, #3e3e3e);
}

.card-light-border {
  border: 1px solid #e0e0e0;
  border: 1px solid var(--grey-border);
}

.card-dark-border {
  border: 1px solid #333333;
  border: 1px solid var(--grey-dark-border);
}

.promotion-tag {
  position: absolute;
  z-index: 99;
  top: 15px;
  left: -10px;
  font-weight: bold;
  font-size: 16px;
  padding: 0 20px;
}

a > h2 {
  transition: all 0.2s ease-in-out;
}

.pointer {
  cursor: pointer;
}

/* a > h2:hover { */
/* transform: skew(-3deg); */
/* text-shadow: 1px 1px 1px #666; */
/* } */
</style>
